import { render, staticRenderFns } from "./saveMentor.vue?vue&type=template&id=41ec151e&"
import script from "./saveMentor.vue?vue&type=script&lang=js&"
export * from "./saveMentor.vue?vue&type=script&lang=js&"
import style0 from "./saveMentor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports